var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarAlertOxygenSaturation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Phantom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M33.5 17 C33.5 26.113 26.113 33.5 17 33.5 7.887 33.5 0.5 26.113 0.5 17 0.5 7.887 7.887 0.5 17 0.5 26.113 0.5 33.5 7.887 33.5 17 Z",
    fill: "none",
    stroke: "#ff335d",
    strokeWidth: 1,
    strokeOpacity: 0.253,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M13.924 12.082 C16.195 11.474 18.506 12.146 20.093 13.656 18.984 13.329 17.775 13.294 16.578 13.615 13.11 14.544 11.053 18.108 11.982 21.575 12.303 22.773 12.938 23.802 13.774 24.598 11.674 23.98 9.937 22.314 9.328 20.043 8.399 16.576 10.457 13.012 13.924 12.082 Z",
    fill: "#ff335d",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy",
    d: "M20.126 22.968 C17.856 23.577 15.544 22.905 13.958 21.395 15.067 21.722 16.275 21.757 17.473 21.436 20.94 20.507 22.998 16.943 22.069 13.475 21.748 12.278 21.113 11.249 20.276 10.453 22.376 11.071 24.114 12.737 24.722 15.008 25.652 18.475 23.594 22.039 20.126 22.968 Z",
    fill: "#ff335d",
    fillOpacity: 1,
    stroke: "none"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlertOxygenSaturation);
export default __webpack_public_path__ + "static/media/avatar-alert-oxygen_saturation.4ac60b724446812887638bf06f27a12a.svg";
export { ForwardRef as ReactComponent };